// Copyright 2025 Diffblue Limited. All Rights Reserved.
// Unpublished proprietary source code.
// Use is governed by https://docs.diffblue.com/licenses/eula

import DreamdataAnalytics from "./DreamdataAnalytics";

/**
 * Tracks and identifies a user via Dreamdata.
 *
 * @param verificationMethod Method of verification used. Either 'email' or 'SSO'.
 * @param email Email address of the user to identify.
 */
export const trackAndIdentifySubmission = async (
  verificationMethod: "email" | "SSO",
  email: string
) => {
  try {
    DreamdataAnalytics.track("Community Edition verified via " + verificationMethod);
    DreamdataAnalytics.identify(null, {
      email
    });
  } catch (error) {
    // Ignore the error, we tried.
    // Do not console log - the user shouldn't see this.
  }
};
